import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { STUDENTS_FEATURE_KEY } from './keys';
import { studentsReducer } from './reducers/students.reducer';
import { StudentsEffects } from './effects/students.effects';

export const adminStudentsStoreProviders = [provideState(STUDENTS_FEATURE_KEY, studentsReducer), provideEffects(StudentsEffects)];

export { StudentsFacade } from './facades/students.facade';
export { StudentsCleanup } from './guards/cleanup.guard';
export { Student } from './models';
